/**
 * Asynchronously loads the component for NotFoundPage
 */

import { lazyLoad } from 'utils/loadable';

export const ComboListPage = lazyLoad(
  () => import('./index'),
  module => module.ComboListPage
);
